import { gql } from '@apollo/client';

/**
 * Ensure the current company has a linked OptiSound shadow account.
 * Idempotent — provisions the shadow account on the OptiSound side if missing,
 * stores the resulting id on `company.optisoundAccountId`, and returns it.
 * Called by the OptiSound embed bridge during ON_INIT when the company has no
 * optisoundAccountId yet, so the embedded portal can authenticate as the shadow
 * account immediately.
 */
export const ENSURE_OPTISOUND_ACCOUNT = gql`
  mutation EnsureOptisoundAccount {
    ensureOptisoundAccount {
      optisoundAccountId
    }
  }
`;

export interface EnsureOptisoundAccountResponse {
  ensureOptisoundAccount: {
    optisoundAccountId: string | null;
  } | null;
}
